import React from 'react';
import Component from '../../components/Component';
import Datagrid from '../../components/Datagrid';
import Renderers from '../../helpers/Renderers';
import DbInfo from '../../dbinfo';
import c from '../../constants';
import {FormManager} from 'reactis-forms';
import {FilterInput, Select, SearchInput} from 'reactis-inputs';
import {FilterResetButton, FilterField} from 'reactis-datagrid';
import {Button, ButtonToolbar} from 'react-bootstrap';
import {AlertWindow} from 'reactis-modal';
import EventEmitter from '../../EventEmitter';
import DateRange from '../../components/Form/DateRange';
import DriverLookup from '../../components/Form/DriverLookup';
import {connect} from 'react-redux';
import ActiveSelect from '../../components/Form/ActiveSelect';
import {bindActionCreators} from 'redux';
import store from 'store2';
import TextInput from "../../reactis/reactis-inputs/TextInput";

const module = 'order';

export default class List extends Component {

	static contextTypes = {
		location: React.PropTypes.object
	};

	constructor(props, context) {
		super(props);

		const rendererLink = (val, row) => {
			return <a href={'/' + module + '/' + row.id} onClick={(e) => this.handleOpen(row, e)}>{val}</a>;
		};

		this.columnModel = [
			{
				name: 'id',
				title: 'ID',
				field: 'id',
				width: 20,
				renderer: rendererLink
			},
			{
				name: 'created',
				title: 'Datum',
				field: 'created',
				width: 120,
				renderer: Renderers.DateTime
			},
			{
				name: 'personal',
				title: 'Typ',
				width: 100,
				field: 'personal',
				renderer: Renderers.DbInfo.bind(DbInfo.OrderPersonal)
			},
			{
				name: 'firm',
				title: 'Firma / řidič',
				field: 'firm',
				renderer: (val, row) => {
					if (row.personal == 2) {
						let drivers = row.items.map((driver) => {
							return driver.surname;
						});
						drivers = drivers.join(', ');
						return row.cTitle + (drivers ? ' (' + drivers + ')': '');
					}
					else {
						return row.items.map((driver) => {
							return driver.name + ' ' + driver.surname + ' - ' + driver.tTitle;
						});
					}

				}
			},
			/*{
				name: 'tTitle',
				title: 'Objednané školení',
				field: 'tTitle',
				renderer: (val, row) => {
					return <span title={val}>{row.tCode}</span>
				}
			},
			{
				name: 'trnumber',
				title: 'Číslo školení',
				width: 110,
				field: 'trnumber',
			},*/
			{
				name: 'price',
				title: 'Cena',
				width: 80,
				renderer: (valuu, row) => {
					return row.price
				}
			},
			{
				name: 'vs',
				title: 'Číslo obj.',
				field: 'vs',
				width: 100,
			},
			{
				name: 'status',
				title: 'Stav',
				field: 'status',
				width: 100,
				renderer: Renderers.DbInfo.bind(DbInfo.OrderStatus)
			},
			{
				name: 'edit',
				title: 'Akce',
				field: 'id',
				width: 80,
				sortable: false,
				renderer: (val, row) => {
					return (
						<a href={'/' + module + '/' + val} onClick={(e) => this.handleOpen(row, e)}>
							<i className="fa fa-pencil position-left"></i>Upravit
						</a>
					);
				}
			}
		];

		const filterSchema = {
			fulltext: {class: SearchInput},
			created: {class: DateRange},
			dTitle: {class: DriverLookup},
			status: {class: Select, options: DbInfo.OrderStatus},
			personal: {class: Select, options: DbInfo.OrderPersonal},
			firm: {class: TextInput},
			vs: {class: TextInput},
			trnumber: {class: TextInput},
			edit: {
				class: FilterResetButton,
				visible: () => this.filter.isChanged(),
				onClick: () => this.filter.reset()
			}
		};
		this.filter = new FormManager(filterSchema);
		const sessionState = store.session.get('dg-' + module);
		// default
		let filter = {};
		// session
		if (sessionState && sessionState.filter) {
			filter = sessionState.filter;
		}
		this.defaultFilter = filter;
		this.defaultSort = sessionState && sessionState.sort ? sessionState.sort : {
			column: 'created',
			'direction': 'desc'
		};

	}

	componentDidMount() {
		this.changeListener = () => {
			this.refs.datagrid.getWrappedInstance().refresh();
		};
		EventEmitter.on(module + '.change', this.changeListener);
	}

	componentWillUnmount() {
		EventEmitter.removeListener(module + '.change', this.changeListener);
	}

	handleOpen(row, e) {
		e.preventDefault();
		this.props.actions.openTabForm(module, '#' + row.id, row);
	}

	handleNewClick(e) {
		e.preventDefault();
		this.props.newTab();
	}

	render() {

		const buttons = <Button href={'/' + module + '/0'} onClick={(e) => this.handleNewClick(e)}>
			<i className="fa fa-plus position-left"/>Nová objednávka
		</Button>;

		return (
			<Datagrid
				ref="datagrid"
				id={module}
				api="order.getList"
				buttons={buttons}
				filters={['fulltext']}
				filter={this.filter}
				saveState={true}
				getRowClassName={null}
				columnModel={this.columnModel}
				defaultFilter={this.defaultFilter}
				forceFilter={this.filterUrl}
				defaultSort={this.defaultSort}
			/>
		)
	}
}


// WEBPACK FOOTER //
// ./src/containers/Order/List.js